import React, { useEffect, useState } from "react";
import {
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import type { Document } from "../../types";
import { operatorDocumentClassLabel } from "../../utils/operatorDocuments";
import DocumentMarkdownPreview from "./DocumentMarkdownPreview";

interface ViewDocumentDialogProps {
  document: Document | null;
  open: boolean;
  onClose: () => void;
  onEdit?: () => void;
}

const ViewDocumentDialog: React.FC<ViewDocumentDialogProps> = ({
  document: doc,
  open,
  onClose,
  onEdit,
}) => {
  const [content, setContent] = useState(doc?.content ?? "");

  useEffect(() => {
    setContent(doc?.content ?? "");
  }, [doc]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Stack spacing={0.5}>
          <Typography variant="h6" component="span">
            {doc?.name ?? "Document"}
          </Typography>
          <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
            {doc?.status && <Chip size="small" label={doc.status} />}
            <Chip size="small" label={operatorDocumentClassLabel(doc?.entityClass)} />
            {doc?.sourceFileName && (
              <Chip size="small" variant="outlined" label={doc.sourceFileName} />
            )}
          </Stack>
        </Stack>
      </DialogTitle>
      <DialogContent dividers>
        {doc?.description && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            {doc.description}
          </Typography>
        )}
        <DocumentMarkdownPreview content={content} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
        {onEdit && (
          <Button variant="contained" onClick={onEdit}>
            Edit
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ViewDocumentDialog;
